import GatedBusinessInfoModule from './GatedBusinessInfoModule';

export default GatedBusinessInfoModule;
